export default __webpack_public_path__ + "static/media/page-title-bg-02.9207e08b.jpg";